import { ServicesData } from './../../services/services.data';
import { MatOption } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatListOption, MatList } from '@angular/material/list';
import { UsersData } from '../users.data';
import { Component, OnInit, Input, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ElementSchemaRegistry } from '@angular/compiler';

@Component({
    selector: 'user-edit-dlg',
    templateUrl: './user-edit-dlg.tmpl.html'
})

export class UserEditDlg implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<UserEditDlg>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private usersData: UsersData,
        private formBuilder: FormBuilder,
        private cdref: ChangeDetectorRef,
        public servicesData: ServicesData,
    ) {

    }
    @ViewChild('selectionList') private selectionList: MatList;


    user: any;
    communicationType;
    contactId: number;
    userEditForm: FormGroup;
    subjects: any[];
    registrationEventTypes: any[];

    selectAll() {
        (<any>this.selectionList).options.forEach(element => {
            element.selected = true;
        });
    }
    unSelectAll() {
        (<any>this.selectionList).options.forEach(element => {
            element.selected = false;
        });
    }
    refresh() {
        this.load();
    }

    private fillForm(p: any): void {
        this.userEditForm.patchValue(p);
        this.cdref.detectChanges();
    }


    // selectionChange(e) {
    //     this.userEditForm.controls['userRoles'].setValue(e.source.options);
    // }
    onAreaListControlChanged(e) {
        let paymentsIds = (<any>this.selectionList).selectedOptions.selected.map(item => item.value);
        this.userEditForm.controls['userRoles'].setValue(paymentsIds);
    }

    subjectsSelectionChange(event) {
        const groupSubjectsArray = <FormArray>this.userEditForm.controls['userCommitmentSubjects'];
        let str = groupSubjectsArray.value.join();
        this.userEditForm.controls['commitmentSubjects'].setValue(str);
    }
    registrationEventTypesSelectionChange(event) {
        const groupRegistrationEventTypesArray = <FormArray>this.userEditForm.controls['userRegistrationEventTypes'];
        let str = groupRegistrationEventTypesArray.value.join();
        this.userEditForm.controls['registrationEventTypes'].setValue(str);
    }



    delete(userName): void {
        let cnfrm = confirm("האם אתה בטוח?,\nלא ניתן לבטל את הפעולה");
        if (cnfrm) {
            this.usersData.delete(userName).subscribe((c: any) => {
                return true;
            });
        }
    }

    private initForm() {
        this.userEditForm = this.formBuilder.group({
            userName: [, Validators.required],
            firstName: [, Validators.required],
            lastName: [, Validators.required],
            password: [],
            department: [, Validators.required],
            userCommitmentSubjects: [, Validators.required],
            commitmentSubjects: [null, Validators.required],
            userRegistrationEventTypes: [, Validators.required],
            registrationEventTypes: [null, Validators.required],
            userRoles: [],
            kvpUserRoles: []
        });
    }


    public load(): void {
        if (this.data && this.data != '') {
            this.usersData.get(this.data)
                .subscribe((p: any) => {
                    this.user = p;
                    this.fillForm(p);
                });
        }
    }

    public loadSubjects(): void {
        this.usersData.getSubjects()
            .subscribe((x: any) => {
                this.subjects = x;

            });
    }

    public loadRegistrationEventTypes(): void {
        this.usersData.getRegistrationEventTypes()
            .subscribe((x: any) => {
                this.registrationEventTypes = x;

            });
    }


    ngOnInit() {
        // this.userName = this.data.userName;
        this.initForm();
        this.cdref.detectChanges();

        this.load();
        this.cdref.detectChanges();
        this.loadSubjects();
        this.loadRegistrationEventTypes();
    }
}



